<template>
  <ol class="g-breadcrumb g-clearfix" itemscope itemtype="http://schema.org/BreadcrumbList">
    <li v-for="(path, index) in pathList" :key="index" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
      <router-link :to="path.path | lang" itemscope itemtype="http://schema.org/Thing" itemprop="item">
        <span itemprop="name">{{ $t(path.text) | join }}</span>
      </router-link>
      <meta itemprop="position" :content="index+1">
    </li>
  </ol>
</template>

<script>
import i18n from '@/i18n.js'

export default {
  props: {
    pathList: { type: Array, required: true },
  },
  filters: {
    // 配列になっている値の結合
    join (val) {
      if (Array.isArray(val)) {
        return val.length ? val.join(', ') : "-"
      } else {
        return val ? val : "-"
      }
    },
    // 英語ページの場合は英語ページへのリンクにする
    lang (path) {
      return i18n.locale == 'en' && path.indexOf('/en') != 0 ? '/en'+path : path
    }
  },
}
</script>
